export default __webpack_public_path__ + "static/media/4.54c39e75.jpg";